<!--  -->
<template>
  <div class="all_box">
    <div
      v-show="handleCurrentChange.length>0"
      class="left_box"
    >
      <div class="dawr_select">
        <el-input
          v-model="query.keywords"
          placeholder="请输入企业名称"
        />
        <el-button
          icon="el-icon-search"
          circle
          style="margin-left:10px"
          @click="sdertw"
        />
      </div>
      <el-table
        ref="singleTable"
        :highlight-current-row="show"
        :data="tableDatalist"
        max-height="773"
        border
        @row-click="handleCurrentChange"
      >
        <el-table-column
          prop="corp_name"
          label="企业名称"
          align="center"
        />
      </el-table>
      <!-- <pagination-right
        :total="total"
        :current-page="query.page"
        :page-sizes="[10]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      /> -->
      <el-pagination
        small
        layout="total,prev, pager, next"
        :current-page="query.page"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
    <div v-if="show2">
      <div class="band_box crop_box">
        <div>
          <div class="serch_box " style="display:flex; align-items:center;flex-wrap:nowrap">
            <!-- <el-input v-model="obr.friend_id" placeholder="请输入自有员工编号" style="width:200px" />
            <el-input v-model="obr.name" placeholder="请输入员工姓名" style="width:200px;margin-left:10px" /> -->
            <el-input
              v-model="obr.nickname"
              clearable
              style="width:220px;"
              placeholder="请输入姓名"
            />
            <!-- <el-select v-model="valueser" placeholder="请选择" @change="chaerwr">
              <el-option
                v-for="item in optionsalll"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select> -->
            <el-button
              type="primary"
              class="search_icon"
              icon="el-icon-search"
              @click="secahclkick"
            />
          </div>
          <div class="choses_box">
            <div
              class="select_box"
              :class="[fullName?'choose_blockr':'']"
              @click="whole"
            />
            <div
              v-if="fullName"
              @click="whole"
            >
              取消全选
            </div>
            <div
              v-else
              @click="whole"
            >
              全选
            </div>
          </div>
          <div class="choose_allblock">
            <div
              v-for="item,index in arr"
              :key="index"
              :class="[item.tips?'have ':'']"
              class="choose_block"
            >
              <!-- {{ item.canChecked }} -->
              <div
                v-if="item.can_checked === 9"
                class="select_boxone"
              />
              <div
                v-else
                class="select_box"
                :class="[item.tips?'choose_blockr':'']"
                @click="itenclick(item,index)"
              />
              <span>{{ item.name }}</span>
            </div>
          </div>

        </div>
        <div class="rigboxr">
          <div class="choiceofficialaccount">选中的人</div>
          <el-tag
            v-for="itemr,index in arrs"
            :key="index"
            style="margin-right:10px;margin-bottom:5px;color: blue;"
            closable
            :type="itemr.type"
            @close="rightclick(itemr.employee_no,index)"
          >
            {{ itemr.name }}
          </el-tag>
        </div>
      </div>
      <!-- <pagination-right
      style="padding:0px;margin-top:20px"
      :total="total"
      :current-page="obr.page"
      :page-size="30"
      :page-sizes="[10,20,30]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    /> -->
      <!-- que_box  -->
      <div class="right_box">
        <el-button
          type="primary"
          @click="quebtn"
        >确定</el-button>
      </div>
    </div>

  </div>
</template>

<script>
// import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { spCorplist, groupChatSetgetCorpColleagues, getEmployeeNoFriend } from '@/api/officialaccount.js'
export default {
  components: {
    // PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],
      arrsw: [],

      obr: {
        // page: 1,
        // page_size: 30,
        employee_no: null,
        nickname: '',
        corp_id: null
      },
      total: null,
      sp_strategy_no: null,
      valueser: 1,
      optionsalll: [
        {
          value: 1,
          label: '外部'
        },
        {
          value: 2,
          label: '内部'
        }
      ],
      loadinggroup: false,
      tableDatalist: [],
      query: {
        page: 1,
        pageSize: 10,
        keywords: null,
        suite_id: null
      },
      show: true,
      show2: false,
      currentRow: null
    }
  },
  computed: {
    fullName: function() {
      return this.arr
        .filter(num => {
          return num.can_checked !== 9
        })
        .every(function(item) {
          return item.tips === true
        })
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleCurrentChange(val) {
      console.log('val:', val)
      this.obr.corp_id = val.corp_id
      this.show2 = true
      this.list()
      this.currentRow = val
      this.arrs = []
      this.arr = []
      this.arrsw = []
    },
    async corpList() {
      console.log(2)
      this.loadinggroup = true
      const data = await spCorplist(this.query)
      this.tableDatalist = data.data.list
      this.total = data.data.total
      this.loadinggroup = false
    },
    sdertw() {
      this.query.page = 1
      this.corpList()
    },
    async sendr(employee_no, corp_id, user, corp_namec) {
      console.log('employee_no, corp_id:', employee_no, corp_id, user, corp_namec)
      this.arrs = user
      this.obr.employee_no = employee_no
      this.obr.corp_id = corp_id
      this.query.keywords = corp_namec
      console.log(1)
      await this.corpList()
      console.log(3, this.tableDatalist)
      const index = this.tableDatalist.findIndex(items => {
        console.log('items.corp_id === corp_id:', items.corp_id === corp_id)
        return items.corp_id === corp_id
      })
      console.log('index:', index)
      this.$refs.singleTable.setCurrentRow(this.tableDatalist[index])
      this.list()
      this.show2 = true
    },
    secahclkick() {
      // this.obr.page = 1
      this.list()
    },
    async list() {
      console.log('arr1111111111111111')
      if (this.valueser === 1) {
        const data = await getEmployeeNoFriend(this.obr)
        // this.total = data.data.total
        if (data.data === null) {
          this.arr = []
        } else {
          data.data.forEach(item => {
            item.can_checked = 1
            item.tips = false
          })
          this.arr = data.data

          this.arr.forEach(item => {
            // console.log('item', item)
            this.arrs.forEach(items => {
              if (items.employee_no === item.wx_id) {
                console.log('items', item)
                item.tips = true
              }
            })
          })
          console.log('data', data)
        }
      } else {
        const data = await groupChatSetgetCorpColleagues({
          corp_id: this.obr.corp_id,
          nickname: this.obr.nickname
        })
        // this.total = data.data.total
        if (data.data === null) {
          this.arr = []
        } else {
          data.data.forEach(item => {
            item.can_checked = 1
            item.tips = false
            item.friend_id = item.wx_id
          })
          this.arr = data.data

          this.arr.forEach(item => {
            // console.log('item', item)
            this.arrs.forEach(items => {
              if (items.employee_no === item.wx_id) {
                console.log('items', item)
                item.tips = true
              }
            })
          })
          console.log('data', data)
        }
      }
    },
    // 点击确定
    async quebtn() {
      console.log('arrs', this.arrs)
      this.arrsw = []
      this.arrsw = this.arrs.map(item => {
        // item是数组中的每一个值
        return item.employee_no
      })
      if (this.arrs.length === 0) {
        this.$message.error('请选择要设置的拉取人')
        return
      }
      this.$emit('bandarr', this.arrs, this.obr.employee_no, [this.obr.corp_id])
    },

    itenclick(item, index) {
      console.log('item, index:', item, index)
      item.tips = !item.tips
      console.log('item.tips:', item.tips, !item.tips)
      if (item.tips) {
        this.arrs.push({ employee_no: item.wx_id, name: item.name })
        console.log('this.arrs:', this.arrs)
      } else {
        console.log('jl')
        const index = this.arrs.findIndex(items => {
          return items.employee_no === item.wx_id
        })
        this.arrs.splice(index, 1)
      }
    },
    whole() {
      if (this.fullName === true) {
        // if (this.arrs.length === this.arr.length) {
        console.log('666')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = false
            const index = this.arrs.findIndex(items => {
              return items.wx_id === item.employee_no
            })
            this.arrs.splice(index, 1)
          }
        })
      } else {
        console.log('777')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = true
            this.arrs.map(re => re.employee_no).includes(item.wx_id) || this.arrs.push({ employee_no: item.wx_id, name: item.name })
          }
        })
        // this.arr.forEach((item) => {
        //   this.arrs.includes(item.id) || this.arr.push(item.id)
        // })
      }
    },
    rightclick(employee_no, index) {
      this.arrs.splice(index, 1)
      this.arr.findIndex(items => {
        if (items.employee_no === employee_no) {
          items.tips = false
        }
      })
    },

    // 分页
    fetchPageSize(e) {
      console.log('111')
      // this.obr.pageSize = e
      // this.obr.page = 1
      this.corpList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.corpList()
    },
    chaerwr(val) {
      console.log(val)
      this.obr.nickname = ''
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox {
  padding: 30px;
}
.que_box {
  margin-top: 20px;
}
.have {
  color: #409eff;
}
.serch_box {
  display: flex;
  margin-bottom: 10px;
}
.search_icon {
  margin-left: 10px;
}
.band_box {
  display: flex;
}
.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_blockr {
  background: #409eff;
}
.rigboxr {
  margin-left: 1px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  /* overflow: hidden; */
  /* overflow-y: scroll; */
}
/* :-webkit-scrollbar {
     width: 0 !important;
}
::-webkit-scrollbar {
     width: 0 !important;height: 0;
  } */
.choiceofficialaccount {
  margin-bottom: 10px;
  width: 100px;
}
.select_spacing {
  margin-bottom: 5px;
}
.choose_allblock {
  height: 370px;
  /* overflow: hidden; */
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 430px;
  overflow-x: scroll;
}
.all_box .crop_box {
  position: relative;
  /* width: 200px; */
  animation: mymove 2s;
  animation-fill-mode: forwards;
  -webkit-animation: mymove 2s forwards;
  margin-right: 40px;
}
.left_box {
  width: 290px;
  margin-right: 40px;
  /* z-index: 50; */
}
.all_box {
  display: flex;
}
.dawr_select {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
@media (max-width: 768px){
  .all_box,.band_box{
    display:flex;
    flex-direction:column !important;
  }
}
</style>
